export const logger = (...message: string[] | object[]) => {
  if (process.env.NODE_ENV === "development") {
    console.error(...message); // eslint-disable-line no-console
  }
};
